import {FC} from 'react'
import {Link} from 'react-router-dom'

const Error500: FC = () => {
  return (
    <>
      {/* begin::Title */}
      <h1 className='fw-bolder fs-2qx text-gray-900 mb-4'>{'System Error'.toTranslatedDisplay()}</h1>
      {/* end::Title */}

      {/* begin::Text */}
      <div className='fw-semibold fs-6 text-gray-500 mb-7'>
        {'Something went wrong! Please try again later.'.toTranslatedDisplay()}
      </div>
      {/* end::Text */}

      {/* begin::Illustration */}
      <div className='mb-11'>
        <i className='bi bi-exclamation-triangle text-warning' style={{fontSize: '8rem'}} />
      </div>
      {/* end::Illustration */}

      {/* begin::Link */}
      <div className='mb-0'>
        <Link to='/dashboard' className='btn btn-sm btn-primary'>
          {'Return Home'.toTranslatedDisplay()}
        </Link>
      </div>
      {/* end::Link */}
    </>
  )
}

export {Error500}
